import { useNavigate } from "react-router-dom";

export default function TopBar({ title, testId = "top-bar", right = null, to = -1 }) {
  const nav = useNavigate();
  return (
    <div data-testid={testId} className="flex items-center justify-between mb-5">
      <button
        data-testid="back-button"
        onClick={() => nav(to)}
        className="joy-press w-11 h-11 rounded-full bg-white flex items-center justify-center text-xl border-2 border-[#FFC0CB]"
        style={{ boxShadow: "0 4px 10px rgba(0,0,0,0.06)" }}
        aria-label="Voltar"
      >
        ←
      </button>
      <h1 className="font-extrabold text-lg text-[#4A3728] text-center flex-1 px-2">{title}</h1>
      <div className="w-11 h-11 flex items-center justify-center">{right}</div>
    </div>
  );
}
